import Vue from "vue";
import Swal from "sweetalert2";
import qs from "querystring";
import * as moment from "moment";
moment.locale("es");

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import UnauthenticatedError from "./errors/UnauthenticatedError";
import ValidationError from "./errors/ValidationError";
Vue.use(Loading);

export default Vue.mixin({
  methods: {
    showSuccessMessage(message) {
      Swal.fire({
        icon: "success",
        title: "",
        html: message,
      });
    },
    showErrorMessage(message) {
      Swal.fire({
        icon: "error",
        title: "",
        html: message,
      });
    },
    showWarningMessage(message) {
      Swal.fire({
        icon: "warning",
        title: "",
        html: message,
      });
    },
    async sendRequest(url, data = {}, method = "GET", files = false) {
      const requestResponse = {
        message: "",
        data: {},
      };

      var requestConfig = {
        method: method,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Authorization:
            "Bearer " +
            (window.localStorage.token ? window.localStorage.token : ""),
        },
      };

      if (Object.keys(data).length || data instanceof FormData) {
        if (files) {
          requestConfig.body = data;
        } else {
          requestConfig.headers["Content-Type"] = "application/json";
          if (method == "GET") {
            url += "?" + qs.stringify(data);
          } else {
            requestConfig.body = JSON.stringify(data);
          }
        }
      }

      return fetch(url, requestConfig)
        .then(async function (httpResponse) {
          if (!httpResponse.ok) {
            const response = { type: "", message: "" };

            if (httpResponse.status == 500) {
              response.type = "error";
              response.message = "Error en la aplicación.";
            }
            if (httpResponse.status == 401) {
              response.type = "warning";
              response.message = "Acceso denegado";
            }

            if (httpResponse.status == 400) {
              response.type = "warning";
              response.message = await httpResponse.json().then((object) => {
                return object.message;
              });
            }

            if (httpResponse.status == 404) {
              response.type = "warning";
              response.message = "Ruta inválida o recurso no encontrado";
            }

            if (httpResponse.status == 422) {
              response.type = "warning";

              response.message = await httpResponse.json().then((object) => {
                var messageUl = document.createElement("ul");
                Object.keys(object.errors).forEach((fields) => {
                  var messageLi = document.createElement("li");
                  var messageText = document.createTextNode(
                    object.errors[fields][0]
                  );
                  messageLi.appendChild(messageText);
                  messageUl.appendChild(messageLi);
                });

                return messageUl.outerHTML;
              });
            }

            throw response;
          } else {
            if (httpResponse.status != 204) {
              return httpResponse.json();
            } else {
              return {};
            }
          }
        })
        .then((response) => {
          if (response.data) requestResponse.data = response.data;
          if (response.message) requestResponse.message = response.message;

          return requestResponse;
        })
        .catch(({ type, message }) => {
          Swal.fire({
            icon: type,
            title: "",
            html: message,
          });
        });
    },
    openLoader() {
      this.load = this.$loading.show({
        container: null,
      });
    },
    closeLoader() {
      this.load.hide();
    },
    formatDate(date) {
      return moment(date).format("LL");
    },
    formatDateTime(date) {
      return moment(date).format("LLL");
    },
    getDate() {
      return moment().format("YYYY-MM-DD");
    },
    clearForm(form) {
      Object.keys(form).map((k) => (form[k] = null));
    },
    async putRequest(url, data = {}) {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      if (undefined !== window.localStorage.token) {
        headers["Authorization"] = `Bearer ${window.localStorage.token}`;
      }

      const response = await fetch(
        `${process.env.VUE_APP_API_URL}/api/${url}`,
        {
          method: "PUT",
          mode: "cors",
          headers,
          body: JSON.stringify(data),
        }
      );

      let jsonResponse = {};

      if (204 !== response.status) {
        jsonResponse = await response.json();
      }

      if (!response.ok) {
        if (422 === response.status) {
          throw new ValidationError(jsonResponse.message, jsonResponse.errors);
        }

        if (401 === response.status) {
          if ("/auth/login" !== window.location.pathname) {
            throw new UnauthenticatedError();
          }
        }

        throw new Error(jsonResponse.error);
      }

      return jsonResponse;
    },
    async deleteRequest(url) {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      if (undefined !== window.localStorage.token) {
        headers["Authorization"] = `Bearer ${window.localStorage.token}`;
      }

      const response = await fetch(
        `${process.env.VUE_APP_API_URL}/api/${url}`,
        {
          method: "DELETE",
          mode: "cors",
          headers,
        }
      );

      let jsonResponse = {};

      if (204 !== response.status) {
        jsonResponse = await response.json();
      }

      if (!response.ok) {
        if (401 === response.status) {
          throw new UnauthenticatedError();
        }

        throw new Error("Error en la aplicación.");
      }

      return jsonResponse;
    },
    async postRequest(url, data = {}) {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      if (undefined !== window.localStorage.token) {
        headers["Authorization"] = `Bearer ${window.localStorage.token}`;
      }

      const response = await fetch(
        `${process.env.VUE_APP_API_URL}/api/${url}`,
        {
          method: "POST",
          mode: "cors",
          headers,
          body: JSON.stringify(data),
        }
      );

      let jsonResponse = {};

      if (204 !== response.status) {
        jsonResponse = await response.json();
      }

      if (!response.ok) {
        if (422 === response.status) {
          throw new ValidationError(jsonResponse.error, jsonResponse.errors);
        }

        if (401 === response.status) {
          if ("/auth/login" !== window.location.pathname) {
            throw new UnauthenticatedError();
          }
        }

        throw new Error(jsonResponse.error);
      }

      return jsonResponse;
    },
  },
});
